// src/App.js

import React, { useState, useEffect } from 'react';
//import './App.css';

import { BrowserRouter as Router, Routes, Route, useParams, Navigate, useLocation } from 'react-router-dom';
import AdminMenu from './components/AdminMenu';
import Metrics from './components/metric/Metrics';
import MetricDetail from './components/metric/MetricDetail';
import Goals from './components/goal/Goals';
import GoalDetail from './components/goal/GoalDetail';
import Reports from './components/Reports';
import ReportDetail from './components/ReportDetail';
import { useMsalAuthentication, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionType, InteractionStatus } from "@azure/msal-browser";
import Overview from './components/overview/Overview';
import { loginRequest } from './authConfig';
import KPIs from './components/kpi/KPIs';
import KpiDetail from './components/kpi/KpiDetail';
import IOSDashboard from './components/dashboard/IOSDashboard';
import RepairDashboard from './components/dashboard/repairs/RepairDashboard';
import Users from './components/user/Users';
import UserDetail from './components/user/UserDetail';
import Groups from './components/Groups';
import Roles from './components/roles/Roles';
import GroupDetail from './components/GroupDetail';
import RoleDetail from './components/roles/RoleDetail';
import AddGroupPage from './components/AddGroupPage';
import AddGoalPage from './components/NewGoalPage';
import UserEdit from './components/user/UserEdit';
import MetricEdit from './components/metric/MetricEdit';
import SalesOverview from './components/sales/SalesOverview';
import RepairsOverview from './components/ios/repairs/RepairsOverview';
import PurchasingOverview from './components/ios/purchasing/PurchasingOverview';
import Repairs from './components/ios/repairs/Repairs';
import Displays from './components/displays/Displays';
import Customers from './components/customers/Customers';
import Customer from './components/customers/Customer';
import Home from './components/Home';
import Inventory from './components/inventory/Inventory';
import Warehouse from './components/warehouse/Warehouse';
import Warranties from './components/warranties/Warranties';
import RMA from './components/rma/RMA';
import About from './components/about/About';
import FrontDesk from './components/frontdesk/FrontDesk';
import Salesperson from './components/sales/salesperson/Salesperson';
import LoginModal from './components/auth/LoginModal';
import AuthenticationInProgress from './components/auth/AuthenticationInProgress';
import VendorOverview from './components/vendors/VendorOverview';
import Vendor from './components/vendors/vendor/Vendor';
import RepairVendor from './components/vendors/vendor/RepairVendor';
import PartsEvalHome from './components/PartsEval/PartsEvalHome';
import PartsEvalDetail from './components/PartsEval/PartsEvalDetail';
import PartsEvalNew from './components/PartsEval/PartsEvalNew';
import AppFeatures from './components/features/AppFeatures';
import Usage from './components/usage/Usage';
import GeneralDashboard from './components/dashboard/GeneralDashboard';
import ReportBug from './components/about/ReportBug';
import ModulesHome from './components/learning/ModulesHome';
//import DWExplorer from './components/DWExplorer/DWExplorer.js.old';
import ClassificationHome from './components/classifications/ClassificationHome.js';
import ClassificationHomeTemp from './components/classifications/ClassificationHomeTemp.js';
import ClassificationDetail from './components/classifications/ClassificationDetail.js';
import ClassificationDetailTemp from './components/classifications/ClassificationDetailTemp.js';

import QueryEditor from './components/QueryCommander/QueryEditor';
import FeatureEditor from './components/QueryCommander/FeatureEditor';

import WizardHome from './components/RepairWizard/WizardHome';
import RepairDetails from './components/dashboard/repairs/RepairDetails';
import DataMartPage from './components/DWExplorer/DataMartPage';

import DatasetsHome from './components/datasets/DatasetsHome';
import DatasetDetail from './components/datasets/DatasetDetail';

import SalesPerformanceScorecardRevenueDetail from './components/sales/salesperson/SalesPerformanceScorecardRevenueDetail';
import SalesPerformanceScorecardPricingDetail from './components/sales/salesperson/SalesPerformanceScorecardPricingDetail';
import SalesPerformanceScorecardBusinessGrowthPaceDetail from './components/sales/salesperson/SalesPerformanceScorecardBusinessGrowthPaceDetail';
import SalesPerformanceScorecardBusinessGrowthQtyDetail from './components/sales/salesperson/SalesPerformanceScorecardBusinessGrowthQtyDetail';
import SalesPerformanceScorecardRetentionDetail from './components/sales/salesperson/SalesPerformanceScorecardRetentionDetails';
import SalesPerformanceScorecardHistoricalPricingDetail from './components/sales/salesperson/SalesPerformanceScorecardHistoricalPricingDetail';

import SalesDepartmentScorecard from './components/sales/department/SalesDepartmentScorecard';
import NewQueryCommanderHome from './components/QueryCommander/NewQueryCommanderHome.jsx';
import QueryHealth from './components/QueryCommander/QueryHealth.jsx';
import SalesDepartmentScorecardRevenueDetails from './components/sales/department/SalesDepartmentScorecardRevenueDetails';
import SalesDepartmentScorecardGrowthQtyDetails from './components/sales/department/SalesDepartmentScorecardGrowthQtyDetails';
import SalesDepartmentScorecardGrowthPaceDetails from './components/sales/department/SalesDepartmentScorecardGrowthPaceDetails';
import SalesDepartmentScorecardPricingDetails from './components/sales/department/SalesDepartmentScorecardPricingDetails';
import SalesDepartmentScorecardRetentionDetails from './components/sales/department/SalesDepartmentScorecardRetentionDetails';
//import Purchasing from './components/supply-chain/purchasing/Purchasing';

import PurchasingDepartmentScorecard from './components/supply-chain/purchasing/department/PurchasingDepartmentScorecard.js';

import PurchasingDepartmentInventoryPlannedSpendDetails from './components/supply-chain/purchasing/department/PurchasingDepartmentInventoryPlannedSpendDetails.js';
import PurchasingDepartmentInventoryLandedSpendDetails from './components/supply-chain/purchasing/department/PurchasingDepartmentInventoryLandedSpendDetails.js';

import PurchasingDepartmentInventoryRevenueDetails from './components/supply-chain/purchasing/department/PurchasingDepartmentInventoryRevenueDetails';
import PurchasingDepartmentInventoryHealthDetails from './components/supply-chain/purchasing/department/PurchasingDepartmentInventoryHealthDetails';


import PurchasingDepartmentNewVendorPODetails from './components/supply-chain/purchasing/department/PurchasingDepartmentNewVendorPODetails.js';
import PurchasingDepartmentNewVendorRFQDetails from './components/supply-chain/purchasing/department/PurchasingDepartmentNewVendorRFQDetails.js';

import RFQDayDetails from './components/supply-chain/purchasing/department/calendar/RFQDayDetails.js';
import PODayDetails from './components/supply-chain/purchasing/department/calendar/PODayDetails.js';
import CallTrackerDetails from './components/supply-chain/purchasing/department/calendar/CallTrackerDetails.js';
import PriceUpdateDetails from './components/supply-chain/purchasing/department/calendar/PriceUpdateDetails.js';

import SalesManagersScorecard from './components/sales/managersScorecard/SalesManagersScorecard.js';
import RepPricingDashboard from './components/sales/manager/RepPricingDashboard';
import AllInvoices from './components/sales/manager/AllInvoices';
import TeamCommission from './components/sales/manager/TeamCommission';
import RepBonusDashboard from './components/sales/manager/RepBonusDashboard';
import InvoiceDetail from './components/sales/manager/InvoiceDetail';
import AllOverrides from './components/sales/manager/AllOverrides';
import SalesOverridesEntry from './components/sales/manager/SalesOverridesEntry';
import OpportunitiesWorklist from './components/sales/opportunities/OpportunitiesWorklist';
import InboundEmails from './components/sales/funnel/InboundEmails';
import RotabullDeals from './components/sales/funnel/RotabullDeals';
import DealPipeline from './components/sales/funnel/DealPipeline';
import GuidanceAdmin from './components/sales/funnel/GuidanceAdmin';
import AiTraffic from './components/ai/AiTraffic';
import ManagerOverview from './components/sales/funnel/ManagerOverview';
import MyDeals from './components/sales/funnel/MyDeals';
import QuotingCockpit from './components/sales/cockpit/QuotingCockpit';
import RotabullCompanyLookup from './components/sales/funnel/RotabullCompanyLookup';
import { WorkspaceScopeProvider } from './workspace/WorkspaceScopeContext';
import NymeriaRail from './components/nymeria/NymeriaRail';
import TeachingConsole from './components/sales/funnel/TeachingConsole';
import NymeriaSettings from './components/nymeria/NymeriaSettings';
import FunnelDocumentation from './components/docs/FunnelDocumentation';
import CommissionDocumentation from './components/docs/CommissionDocumentation';
import { Switch as MantineSwitch } from '@mantine/core';
import PurchasingManagersScorecard from './components/supply-chain/purchasing/managersScorecard/PurchasingMangersScorecard.js';
import PurchasingIndividualScorecard from './components/supply-chain/purchasing/individualScorecard/PurchasingIndividualScorecard.jsx';

import PurchasingIndividualNewVendorPODetails from './components/supply-chain/purchasing/individualScorecard/PurchasingIndividualNewVendorPODetails.js';
import PurchasingIndividualInventoryHealthDetails from './components/supply-chain/purchasing/individualScorecard/PurchasingIndividualInventoryHealthDetails.js';
import PurchasingIndividualInventoryRevenueDetails from './components/supply-chain/purchasing/individualScorecard/PurchasingIndividualRevenueDetails.js';
import PurchasingIndividualInventoryLandedSpendDetails from './components/supply-chain/purchasing/individualScorecard/PurchasingIndividualInventoryLandedSpendDetails.js';
import PurchasingIndividualInventoryPlannedSpendDetails from './components/supply-chain/purchasing/individualScorecard/PurchasingIndividualInventoryPlannedSpendDetails.js';
import PurchasingIndividualNewVendorRFQDetails from './components/supply-chain/purchasing/individualScorecard/PurchasingIndividualNewVendorRFQDetails.js';

import InventoryMatcher from './components/InventoryMatcher/InventoryMatcher.jsx';

import RepairsDepartmentScorecard from './components/supply-chain/repairs/departmentScorecard/RepairsDepartmentScorecard';

import RepairsDepartmentInventoryPlannedSpendDetails from './components/supply-chain/repairs/departmentScorecard/details/RepairsDepartmentInventoryPlannedSpendDetails';
import RepairsDepartmentInventoryLandedSpendDetails from './components/supply-chain/repairs/departmentScorecard/details/RepairsDepartmentInventoryLandedSpendDetails';
import RepairsDepartmentInventoryRevenueDetails from './components/supply-chain/repairs/departmentScorecard/details/RepairsDepartmentInventoryRevenueDetails';
import RepairsDepartmentInventoryHealthDetails from './components/supply-chain/repairs/departmentScorecard/details/RepairsDepartmentInventoryHealthDetails';
import RepairsDepartmentNewVendorPODetails from './components/supply-chain/repairs/departmentScorecard/details/RepairsDepartmentNewVendorPODetails';
import RepairsDepartmentNewVendorRFQDetails from './components/supply-chain/repairs/departmentScorecard/details/RepairsDepartmentNewVendorRFQDetails';

import RepairsIndividualInventoryPlannedSpendDetails from './components/supply-chain/repairs/individualScorecard/details/RepairsIndividualInventoryPlannedSpendDetails';
import RepairsIndividualInventoryLandedSpendDetails from './components/supply-chain/repairs/individualScorecard/details/RepairsIndividualInventoryLandedSpendDetails';
import RepairsIndividualInventoryRevenueDetails from './components/supply-chain/repairs/individualScorecard/details/RepairsIndividualInventoryRevenueDetails';
import RepairsIndividualInventoryHealthDetails from './components/supply-chain/repairs/individualScorecard/details/RepairsIndividualInventoryHealthDetails';
import RepairsIndividualNewVendorPODetails from './components/supply-chain/repairs/individualScorecard/details/RepairsIndividualNewVendorPODetails';
import RepairsIndividualNewVendorRFQDetails from './components/supply-chain/repairs/individualScorecard/details/RepairsIndividualNewVendorRFQDetails';

import RepairsManagersScorecard from './components/supply-chain/repairs/managersScorecard/RepairsManagersScorecard';

import RepairsIndividualScorecard from './components/supply-chain/repairs/individualScorecard/RepairsIndividualScorecard.jsx';


import UserGroupManagement from './components/admin/UserGroupManagement.jsx';
import ServiceControl from './components/admin/ServiceControl.jsx';
import GoalManagement from './components/admin/GoalManagement.jsx';

import ScorecardAdmin from './components/admin/ScorecardAdmin.jsx';

import AcceleratorDashboard from './components/accelerator/AcceleratorDashboard.jsx';
import QuickQuote from './components/accelerator/QuickQuote.jsx';
import FleetExplorer from './components/data/FleetExplorer.jsx';
import FleetAnalyzer from './components/data/FleetAnalyzer.jsx';
import QuoteSelect from './components/ERP/Quotes/QuoteSelect.jsx';
import QuoteEdit from './components/ERP/Quotes/QuoteEdit/QuoteEdit.jsx';
import RFQQuoteTraffic from './components/ERP/RFQQuoteTraffic/RFQQuoteTraffic.js';
import RotabullPricing from './components/ERP/RotabullPricing/RotabullPricing.js';
import RotabullSimulation from './components/ERP/RotabullSimulation/RotabullSimulation.js';
import QuotesAnalytics from './components/ERP/QuotesAnalytics/QuotesAnalytics.js';
import HeaderGrid from './components/ERP/SmartQuote/HeaderGrid.jsx';

// Initiatives — 2026 objectives & KPIs. Experimental-only in the menu.
import InitiativesOverview from './components/initiatives/InitiativesOverview.jsx';
import Pillar3Scorecard from './components/initiatives/Pillar3Scorecard.jsx';
import ManagedPartsCoverage from './components/initiatives/kpi/ManagedPartsCoverage.jsx';
import SspDeviation from './components/initiatives/kpi/SspDeviation.jsx';
import UnmanagedPartsSales from './components/initiatives/kpi/UnmanagedPartsSales.jsx';
import RepairExpectedVsActual from './components/initiatives/kpi/RepairExpectedVsActual.jsx';
import MarginByInventoryBucket from './components/initiatives/kpi/MarginByInventoryBucket.jsx';
import QuoteToClose from './components/initiatives/kpi/QuoteToClose.jsx';
import ManagedVsUnmanagedSegments from './components/initiatives/kpi/ManagedVsUnmanagedSegments.jsx';
import ManagedSalesAgeVsReturns from './components/initiatives/kpi/ManagedSalesAgeVsReturns.jsx';
import TransactionQuality from './components/initiatives/kpi/TransactionQuality.jsx';

import QuoteCreationWizard from './components/ERP/SmartQuote/QuoteCreationWizard.jsx';

const MetricDetailWrapper = () => {
  const { id } = useParams();
  return <MetricDetail metricId={id} />;
};

const GoalDetailWrapper = () => {
  const { id } = useParams();
  return <GoalDetail goalId={id} />;
};

const KpiDetailWrapper = () => {
  const { id } = useParams();
  return <KpiDetail kpiId={id} />;
};

const ReportDetailWrapper = () => {
  const { id } = useParams();
  return <ReportDetail reportId={id} />;
};

// The opportunity detail page was merged into the cockpit; keep old links/bookmarks working
// by redirecting /sales/opportunities/:dealId → the cockpit positioned on that deal.
function OpportunityRedirect() {
  const { dealId } = useParams();
  return <Navigate to={`/sales/cockpit?start=${encodeURIComponent(dealId)}`} replace />;
}

// Nymeria — strictly additive on/off assistant. Scoped to the quoting cockpit and the
// opportunities pages for now (renders nowhere else). Off = the rail isn't rendered, no
// agent, no calls; Vesper is fully functional either way. On/off persists in localStorage.
const NYMERIA_ROUTES = ['/sales/cockpit', '/sales/opportunities'];
function NymeriaDock() {
  const location = useLocation();
  const [nymeriaOn, setNymeriaOn] = useState(localStorage.getItem('nymeriaOn') === 'true');
  useEffect(() => { localStorage.setItem('nymeriaOn', String(nymeriaOn)); }, [nymeriaOn]);

  if (!NYMERIA_ROUTES.some((r) => location.pathname.startsWith(r))) return null;

  return (
    <>
      <div style={{ position: 'fixed', bottom: 16, right: nymeriaOn ? 396 : 16, zIndex: 210,
                    display: 'flex', alignItems: 'center', gap: 8, background: 'var(--mantine-color-body)',
                    border: '1px solid var(--mantine-color-default-border)', borderRadius: 999, padding: '6px 12px', boxShadow: '0 2px 8px rgba(0,0,0,0.12)' }}>
        <MantineSwitch size="sm" checked={nymeriaOn} onChange={(e) => setNymeriaOn(e.currentTarget.checked)}
          label="AI Sales Agent" labelPosition="left" color="grape" />
      </div>
      {nymeriaOn && <NymeriaRail onOff={setNymeriaOn} />}
    </>
  );
}

function App() {
  const [open, setOpen] = useState(
    localStorage.getItem('drawerOpen') === 'false' ? false : true
  );

  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { login } = useMsalAuthentication(InteractionType.Redirect, loginRequest);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  // Persist drawer state in localStorage
  useEffect(() => {
    localStorage.setItem('drawerOpen', open.toString());
  }, [open]);

  // Control modal visibility based on authentication and interaction status
  useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      setModalIsOpen(true);
    } else {
      setModalIsOpen(false);
    }
  }, [isAuthenticated, inProgress]);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const handleLogin = async () => {
    try {
      await login();
      setModalIsOpen(false);
    } catch (error) {
      console.error("Login failed:", error);
      // Optionally, handle login failure (e.g., show an error message)
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  // Show a loading indicator while authentication is in progress
  if (inProgress === InteractionStatus.Startup || inProgress === InteractionStatus.HandleRedirect) {
    return;
  }

  return (

    <Router>
      <WorkspaceScopeProvider>
      <AdminMenu opened={open} toggleDrawer={toggleDrawer} >

        <Routes>
          <Route path="/" element={<SalesDepartmentScorecard />} />

          <Route path="/metrics" element={<Metrics />} />
          <Route path="/metrics/:id" element={<MetricDetailWrapper />} />
          <Route path="/metrics/:metricId/edit" element={<MetricEdit />} />

          <Route path="/goals" element={<Goals />} />
          <Route path="/goals/new" element={<AddGoalPage />} />

          <Route path="/goal/:id" element={<GoalDetailWrapper />} />

          <Route path="/kpis" element={<KPIs />} />
          <Route path="/kpi/:id" element={<KpiDetailWrapper />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/reports/:id" element={<ReportDetailWrapper />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/home" element={<Home />} />
          <Route path="/users" element={<Users />} />

          <Route path="/users/:userId" element={<UserDetail />} />
          <Route path="/users/:userId/edit" element={<UserEdit />} />

          <Route path="/groups" element={<Groups />} />
          <Route path="/groups/new" element={<AddGroupPage />} />
          <Route path="/group/:groupId" element={<GroupDetail />} />

          <Route path="/roles" element={<Roles />} />
          <Route path="/roles/:roleId" element={<RoleDetail />} />

          <Route path="/sales-overview" element={<SalesOverview />} />
          <Route path="/sales/salesperson" element={<Salesperson />} />

          <Route path="/repair-vendors" element={<VendorOverview />} />
          <Route path="/repair-vendors/vendor" element={<RepairVendor />} />

          <Route path="/repairs-overview" element={<RepairVendor />} />
          <Route path="/repairs" element={<Repairs />} />

          <Route path="/ios/purchasing-overview" element={<PurchasingOverview />} />

          <Route path="/displays" element={<Displays />} />

          <Route path="/inventory" element={<Inventory />} />

          <Route path="/customers" element={<Customers />} />
          <Route path="/customer" element={<Customer />} />

          <Route path="/warehouse" element={<Warehouse />} />
          <Route path="/warranties" element={<Warranties />} />
          <Route path="/rmas" element={<RMA />} />

          <Route path="/frontdesk" element={<FrontDesk />} />

          <Route path="/about" element={<About />} />

          <Route path="/parts-evaluation" element={<PartsEvalHome />} />
          <Route path="/parts-evaluation/new" element={<PartsEvalNew />} />
          <Route path="/parts-evaluation/detail/:id" element={<PartsEvalDetail />} />

          <Route path="/app-features" element={<AppFeatures />} />

          <Route path="/usage" element={<Usage />} />

          <Route path="/bug-report" element={<ReportBug />} />

          <Route path="/learn/modules" element={<ModulesHome />} />

          <Route path="/dwexplorer" element={<DataMartPage />} />

          <Route path="/repair-dashboard" element={<RepairDashboard />} />

          <Route path="/repair-details" element={<RepairDetails />} />

          <Route path="/datasets" element={<DatasetsHome />} />

          <Route path="/datasets/:key" element={<DatasetDetail />} />

          <Route path="sales/salesperson/:ccode/scorecard/revenue/:mode" element={<SalesPerformanceScorecardRevenueDetail />} />
          <Route path="sales/salesperson/:ccode/scorecard/pricing/history" element={<SalesPerformanceScorecardHistoricalPricingDetail />} />
          <Route path="sales/salesperson/:ccode/scorecard/pricing/:mode" element={<SalesPerformanceScorecardPricingDetail />} />
          <Route path="sales/salesperson/:ccode/scorecard/new-business-growth-pace/:mode" element={<SalesPerformanceScorecardBusinessGrowthPaceDetail />} />
          <Route path="sales/salesperson/:ccode/scorecard/new-business-growth-qty/:mode" element={<SalesPerformanceScorecardBusinessGrowthQtyDetail />} />
          <Route path="sales/salesperson/:ccode/scorecard/retention/:mode" element={<SalesPerformanceScorecardRetentionDetail />} />

          <Route path="sales/department/scorecard" element={<SalesDepartmentScorecard />} />
          <Route path="sales/department/scorecard/revenue-details" element={<SalesDepartmentScorecardRevenueDetails />} />
          <Route path="sales/department/scorecard/new-business-growth-qty-details" element={<SalesDepartmentScorecardGrowthQtyDetails />} />
          <Route path="sales/department/scorecard/new-business-growth-pace-details" element={<SalesDepartmentScorecardGrowthPaceDetails />} />
          <Route path="sales/department/scorecard/pricing-details" element={<SalesDepartmentScorecardPricingDetails />} />
          <Route path="sales/department/scorecard/retention-details" element={<SalesDepartmentScorecardRetentionDetails />} />


          <Route path="supply-chain/purchasing/department/scorecard" element={<PurchasingDepartmentScorecard />} />

          <Route path="supply-chain/purchasing/department/scorecard/inventory-planned-spend-details" element={<PurchasingDepartmentInventoryPlannedSpendDetails />} />
          <Route path="supply-chain/purchasing/department/scorecard/inventory-landed-spend-details" element={<PurchasingDepartmentInventoryLandedSpendDetails />} />
          <Route path="supply-chain/purchasing/department/scorecard/inventory-revenue-details" element={<PurchasingDepartmentInventoryRevenueDetails />} />
          <Route path="supply-chain/purchasing/department/scorecard/inventory-health-details" element={<PurchasingDepartmentInventoryHealthDetails />} />
          <Route path="supply-chain/purchasing/department/scorecard/new-vendor-po-details" element={<PurchasingDepartmentNewVendorPODetails />} />
          <Route path="supply-chain/purchasing/department/scorecard/new-vendor-rfq-details" element={<PurchasingDepartmentNewVendorRFQDetails />} />

          <Route path="supply-chain/purchasing/:ccode/scorecard/inventory-planned-spend-details" element={<PurchasingIndividualInventoryPlannedSpendDetails />} />
          <Route path="supply-chain/purchasing/:ccode/scorecard/inventory-landed-spend-details" element={<PurchasingIndividualInventoryLandedSpendDetails />} />
          <Route path="supply-chain/purchasing/:ccode/scorecard/inventory-revenue-details" element={<PurchasingIndividualInventoryRevenueDetails />} />
          <Route path="supply-chain/purchasing/:ccode/scorecard/inventory-health-details" element={<PurchasingIndividualInventoryHealthDetails />} />
          <Route path="supply-chain/purchasing/:ccode/scorecard/new-vendor-po-details" element={<PurchasingIndividualNewVendorPODetails />} />
          <Route path="supply-chain/purchasing/:ccode/scorecard/new-vendor-rfq-details" element={<PurchasingIndividualNewVendorRFQDetails />} />

          <Route path="supply-chain/purchasing/scorecard" element={<PurchasingIndividualScorecard />} />

          <Route
            path="supply-chain/purchasing/department/scorecard/rfq-day-details"
            element={<RFQDayDetails />}
          />
          <Route
            path="supply-chain/purchasing/department/scorecard/po-day-details"
            element={<PODayDetails />}
          />
          <Route
            path="supply-chain/purchasing/department/scorecard/call-tracker-day-details"
            element={<CallTrackerDetails />}
          />
          <Route
            path="supply-chain/purchasing/department/scorecard/price-update-day-details"
            element={<PriceUpdateDetails />}
          />



          <Route path="supply-chain/repairs/department/scorecard" element={<RepairsDepartmentScorecard />} />

          <Route path="supply-chain/repairs/department/scorecard/inventory-planned-spend-details" element={<RepairsDepartmentInventoryPlannedSpendDetails />} />
          <Route path="supply-chain/repairs/department/scorecard/inventory-landed-spend-details" element={<RepairsDepartmentInventoryLandedSpendDetails />} />
          <Route path="supply-chain/repairs/department/scorecard/inventory-revenue-details" element={<RepairsDepartmentInventoryRevenueDetails />} />
          <Route path="supply-chain/repairs/department/scorecard/inventory-health-details" element={<RepairsDepartmentInventoryHealthDetails />} />
          <Route path="supply-chain/repairs/department/scorecard/new-vendor-ro-details" element={<RepairsDepartmentNewVendorPODetails />} />
          <Route path="supply-chain/repairs/department/scorecard/new-vendor-rfq-details" element={<RepairsDepartmentNewVendorRFQDetails />} />

          <Route path="supply-chain/repairs/:ccode/scorecard/inventory-planned-spend-details" element={<RepairsIndividualInventoryPlannedSpendDetails />} />
          <Route path="supply-chain/repairs/:ccode/scorecard/inventory-landed-spend-details" element={<RepairsIndividualInventoryLandedSpendDetails />} />
          <Route path="supply-chain/repairs/:ccode/scorecard/inventory-revenue-details" element={<RepairsIndividualInventoryRevenueDetails />} />
          <Route path="supply-chain/repairs/:ccode/scorecard/inventory-health-details" element={<RepairsIndividualInventoryHealthDetails />} />
          <Route path="supply-chain/repairs/:ccode/scorecard/new-vendor-ro-details" element={<RepairsIndividualNewVendorPODetails />} />
          <Route path="supply-chain/repairs/:ccode/scorecard/new-vendor-rfq-details" element={<RepairsIndividualNewVendorRFQDetails />} />


          <Route path="supply-chain/repairs/scorecard" element={<RepairsIndividualScorecard />} />




          <Route path="/query-commander" element={<NewQueryCommanderHome />} />
          <Route path="/query-commander/health" element={<QueryHealth />} />
          <Route path="/query-commander/editor" element={<QueryEditor />} />
          <Route path="/query-commander/feature-editor" element={<FeatureEditor />} />


          <Route path="/part-classifications" element={<ClassificationHomeTemp />} />


          {/* scorecard admin */}
          <Route path="/admin/scorecards" element={<ScorecardAdmin />} />
          <Route path="/admin/manage-goals" element={<GoalManagement />} />
          <Route path="/admin/manage-groups" element={<UserGroupManagement />} />
          <Route path="/admin/services" element={<ServiceControl />} />

          <Route
            path="/part-classifications/:id"
            element={<ClassificationDetailTemp />}
          />

          {/* Redirect any unknown routes to home or a 404 component */}
          <Route path="/sales/opportunities" element={<OpportunitiesWorklist />} />
          <Route path="/sales/opportunities/:dealId" element={<OpportunityRedirect />} />
          <Route path="/sales/funnel/inbound-emails" element={<InboundEmails />} />
          <Route path="/sales/funnel/rotabull-deals" element={<RotabullDeals />} />
          <Route path="/sales/funnel/deal/:publicId" element={<DealPipeline />} />
          <Route path="/sales/funnel/guidance" element={<GuidanceAdmin />} />
          <Route path="/ai/traffic" element={<AiTraffic />} />
          <Route path="/sales/funnel/manager-overview" element={<ManagerOverview />} />
          <Route path="/sales/funnel/my-deals" element={<MyDeals />} />
          <Route path="/sales/cockpit" element={<QuotingCockpit />} />
          <Route path="/sales/funnel/rotabull-companies" element={<RotabullCompanyLookup />} />
          <Route path="/sales/funnel/teaching" element={<TeachingConsole />} />
          <Route path="/sales/funnel/nymeria-settings" element={<NymeriaSettings />} />
          <Route path="/sales/funnel/documentation" element={<FunnelDocumentation />} />

          <Route path="*" element={<Navigate to="/" />} />

          <Route
            path="/sales/manager/scorecard"
            element={<SalesManagersScorecard />}
          />
          {/* <Route path="/sales/overrides" element={<SalesOverridesEntry />} /> */}
          <Route path="/sales/manager" element={<RepPricingDashboard />} />
          {/* Top-level path (not under /manager/commissions) so it can't be read as a :repCode */}
          <Route path="/sales/commissions/documentation" element={<CommissionDocumentation />} />
          <Route path="/sales/manager/commissions" element={<TeamCommission />} />
          <Route path="/sales/manager/commissions/:repCode" element={<RepBonusDashboard />} />
          <Route path="/sales/manager/invoices" element={<AllInvoices />} />
          <Route path="/sales/manager/invoices/:docNo/:line" element={<InvoiceDetail />} />
          <Route path="/sales/manager/overrides" element={<AllOverrides />} />

          <Route
            path="/supply-chain/purchasing/manager/scorecard"
            element={<PurchasingManagersScorecard />}
          />

          <Route
            path="/supply-chain/repairs/manager/scorecard"
            element={<RepairsManagersScorecard />}
          />

          <Route
            path="/sales-accelerator"
            element={<AcceleratorDashboard />}
          />



          <Route
            path="/data/fleet-explorer"
            element={<FleetExplorer />}
          />

          <Route
            path="/data/fleet-analyzer"
            element={<FleetAnalyzer />}
          />


          <Route
            path="/sales/inventory-matcher"
            element={<InventoryMatcher />}
          />


          <Route path="/erp/rotabull-pricing" element={<RotabullPricing />} />
          <Route path="/erp/rfq-quote-traffic" element={<RFQQuoteTraffic />} />
          <Route path="/erp/rotabull-simulation" element={<RotabullSimulation />} />
          <Route path="/erp/quotes-analytics" element={<QuotesAnalytics />} />

          {/* Initiatives — 2026 objectives & KPIs */}
          <Route path="/initiatives" element={<InitiativesOverview />} />
          <Route path="/initiatives/scorecard" element={<Pillar3Scorecard />} />
          <Route path="/initiatives/kpi/managed-parts-coverage" element={<ManagedPartsCoverage />} />
          <Route path="/initiatives/kpi/ssp-deviation" element={<SspDeviation />} />
          <Route path="/initiatives/kpi/unmanaged-parts-sales" element={<UnmanagedPartsSales />} />
          <Route path="/initiatives/kpi/repair-expected-vs-actual" element={<RepairExpectedVsActual />} />
          <Route path="/initiatives/kpi/margin-by-inventory-bucket" element={<MarginByInventoryBucket />} />
          <Route path="/initiatives/kpi/transaction-quality" element={<TransactionQuality />} />
          <Route path="/initiatives/kpi/quote-to-close" element={<QuoteToClose />} />
          <Route path="/initiatives/kpi/managed-vs-unmanaged-segments" element={<ManagedVsUnmanagedSegments />} />
          <Route path="/initiatives/kpi/managed-sales-age-vs-returns" element={<ManagedSalesAgeVsReturns />} />

          <Route path="/erp/quotes/edit/:docNo" element={<QuoteEdit />} />

          <Route
            path="/erp/quotes/new-wizard"
            element={<QuoteCreationWizard />}
          />

          <Route
            path="/erp/quotes"
            element={<QuoteSelect />}
          />


        </Routes>
      </AdminMenu>

      {/* Nymeria — on/off pill + rail, scoped to the cockpit page for now. */}
      {isAuthenticated && <NymeriaDock />}
      </WorkspaceScopeProvider>
      {!isAuthenticated && (
        <LoginModal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          onLogin={handleLogin}
        />
      )}

    </Router>

  );
}

export default App;